export function resolveBannerBackgroundStyle(
    backgroundImagePath: string | null | undefined
): { backgroundImage: string } | undefined {
    if (!backgroundImagePath) {
        return undefined;
    }

    return {
        backgroundImage: `url('${backgroundImagePath}')`,
    };
}

export function resolveBannerDescriptionText(
    description: string | null | undefined,
    fallbackDescription: string
): string {
    return description?.trim() || fallbackDescription;
}
